import { AfterViewInit, Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { IntegrationCompany } from 'sharedGuiSmall/enums';
import { Utils } from "sharedGuiSmall/utils/utils";
import { AccessToken } from "sign-up-app/login/AccessToken";
import { AuthAppService } from "sign-up-app/services/auth.service";
import { RegisterUser } from "sign-up-app/sign-up/RegisterUser";
import { RedirectGlobalService } from 'sharedGuiSmall/sharedServices/redirectGlobal.service';
import { TranslateService } from '@ngx-translate/core'

@Component({
    selector: 'sign-in',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.less', '../../forms_style.less'],
})
export class LoginComponent implements OnInit, AfterViewInit {

    newUser = new RegisterUser();
    password: string = '';
    keepSignedIn: boolean = false;

    isEmailValid: boolean = false;
    isPasswordValid: boolean = false;
    isEmailChanged: boolean = false;
    isLicenseNotActivatedError: boolean = false;
    fullLiveUrl = window.fullLiveUrl;
    idSrvUrl = window.idSrvUrl;
    idAccessTokenName = window.idAccessTokenName;
    idCookieDomain = window.idCookieDomain;
    integrationCompany = IntegrationCompany;
    hasExistingAccount = window.hasExistingAccount;
    needEmailVerification = window.needQBEmailVerification;
    needFBEmail = window.needFBEmail;
    modalTitle = "Please sign in with another method";
    modalText = "The crunch email address you tried to sign in with is already associated with a Brixx account. Please sign into this account using your Brixx password.";
    isQBSSO = window.isQBSSO;
    isAppleButtonVisible = window.isAppleButtonVisible;
    isCrunchButtonVisible = window.isCrunchButtonVisible;

    logInButtonText = $localize`:@@logInButton:LOG_IN`;
    xeroLogInButtonText = $localize`:@@xeroLogInButton:LOG_IN_WITH_XERO`;
    crunchSignInButtonText = $localize`:@@crunchSignInButton:LOG_IN_WITH_CRUNCH`;
    googleLogInButtonText = $localize`:@@googleLogInButton:LOG_IN_WITH_GOOGLE`;
    appleLogInButtonText = $localize`:@@appleLogInButton:LOG_IN_WITH_APPLE`;
    facebookLogInButtonText = $localize`:@@facebookLogInButton:LOG_IN_WITH_FACEBOOK`;

    emailAddressRequired = $localize`The Email Address field must be completed`;
    notValidEmail = $localize`Not a valid email`;
    passwordRequired = $localize`The Password field must be completed`;
    incorrectEmailOrPassword = $localize`INCORRECT_EMAIL_OR_PASSWORD`;

    get showModal() {
        return this.hasExistingAccount || this.needEmailVerification || this.needFBEmail;
    }

    @ViewChild('emailInput')
    private emailInput!: ElementRef<HTMLInputElement>;

    @ViewChild('passwordInput')
    private passwordInput!: ElementRef<HTMLDivElement>;

    @ViewChild('emailWrongMsg')
    private emailWrongMsg!: ElementRef<HTMLInputElement>;

    @ViewChild('passwordWrongMsg')
    private passwordWrongMsg!: ElementRef<HTMLDivElement>;

    isBusinessDoctors: boolean = false;

    constructor(
        private authService: AuthAppService,
        private redirectService: RedirectGlobalService,
        private translate: TranslateService
    ) {
        this.isBusinessDoctors = (String)(window['isBusinessDoctors']).toLowerCase() === 'true';
    }

    ngAfterViewInit(): void {
        const authError = Utils.getCookie("authError");
        if (authError) {
            this.authService.AddErrorMessage(this.passwordInput, this.passwordWrongMsg, authError);
            Utils.deleteCookie("authError");
        }
    }

    ngOnInit() {
        this.isEmailChanged = Utils.getCookie("userEmailChanged") == "true";

        if (this.needEmailVerification) {
            this.modalTitle = "Please verify your QuickBooks email address";
            this.modalText = "";
        }

        if (this.needFBEmail) {
            this.modalTitle = "Brixx app requires an email for full functionality. There is no email address associated with your Facebook account so please register via email.";
            this.modalText = "";
        }

        this.loadTranslations(); // Dynamically load translations

        // Listen for language changes and update translations

        this.translate.onLangChange.subscribe(() => {

            this.loadTranslations();

        });
    }

    closePopup() {
        this.hasExistingAccount = false;
        this.needEmailVerification = false;
        this.needFBEmail = false;
    }

    getRootDomain(url: string) {
        return url?.replace(/^(?:https?:\/\/)?(?:[^\/]+\.)?([^.\/]+\.[^.\/]+).*$/, "$1");
    }

    clearIdentityCookie(cookie_name: string, cookie_domain: string) {
        document.cookie = `${cookie_name}=; path=/; domain=${cookie_domain}; expires=${new Date(0).toUTCString()}`;
    }

    validateEmail(): void {
        this.loadTranslations();
        this.isEmailValid = this.authService.ValidateField(this.emailInput, this.emailWrongMsg, this.newUser.email, ['required', 'email'],
            { 'required': this.emailAddressRequired, 'email': this.notValidEmail });
    }

    validatePassword(): void {
        this.loadTranslations();
        console.log('2nd password-', this.passwordRequired);
        this.isPasswordValid = this.authService.ValidateField(this.passwordInput, this.passwordWrongMsg, this.newUser.passwordStr, ['required'],
            { 'required': this.passwordRequired });
    }

    goToSignIn(): void {
        window.location.href = this.fullLiveUrl+'sign-in';
        //this.router.navigate(['signIn'], { replaceUrl: true });
    }

    goToMainSite(): void {
        window.location.href = "https://www.brixx.com";
    }

    goToForgottenPassword(): void {
        //window.rootPageName = 'forgotten-password';
        window.location.href = this.fullLiveUrl+'forgotten-password';
        //this.router.navigate(['forgottenPassword'], { replaceUrl: true });
    }

    goToSignUp(): void {
        window.location.href = this.fullLiveUrl+'sign-up/foundation';
        //this.router.navigate(['sign-up'], { replaceUrl: true });
    }

    goToVerificationEmail(): void {
        window.location.href = this.fullLiveUrl + 'verification-email';
    }

    resendLink(): void {
        this.isLicenseNotActivatedError = false;
        localStorage.setItem('newUserEmail', this.newUser.email);

        this.authService.resendVerificationEmail(this.newUser.email)

        this.goToVerificationEmail();
    }

    toggleKeepSignedIn(): void {
        this.keepSignedIn = !this.keepSignedIn;
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event.key == "Enter")
            this.signIn();
    }

    signIn(): void {

        this.validateEmail();
        this.validatePassword();
        this.isLicenseNotActivatedError = false;

        if (this.isEmailValid && this.isPasswordValid) {

            this.authService.toggleSpinner();

            // clear identity cookie for main url
            this.clearIdentityCookie(this.idAccessTokenName, this.idCookieDomain);
            // BR-5292 to avoid bxbuild login troubles, clear identity cookie with dot before url name
            this.clearIdentityCookie(this.idAccessTokenName, `.${this.idCookieDomain}`);
            // BR-5292 to avoid bxbuild login troubles, clear identity cookie for root domain name
            this.clearIdentityCookie(this.idAccessTokenName, `.${this.getRootDomain(this.idCookieDomain)}`);
            // clear local storage access token value
            localStorage.setItem("accessToken", '');
            localStorage.setItem('newUserEmail', this.newUser.email);

            const data = {
                username: this.newUser.email,
                password: this.newUser.passwordStr,
                grant_type: 'password',
                scope: 'brixxlive_site'
            };

            this.authService.GetToken(this.fullLiveUrl + 'Auth/GenerateMD5Password', data).then((result: any) => {
                const res: AccessToken = JSON.parse(result);
                if (res && res.access_token) {
                    const token = res.access_token;
                    const data = { 'isRememberMe': this.keepSignedIn, 'token': token };

                    this.authService.OnSSOLogin(this.fullLiveUrl + 'Account/OnSSOLogin', data).then((res: string) => {
                        document.cookie = 'userEmailChanged=false';

                        let data = { success: true, errorMessage: '' };
                        if (res && res.length)
                            data = JSON.parse(res);

                        if (data.success) {
                            try {
                                document.location.href = this.fullLiveUrl + 'Account/OnAfterSSOLogin';
                            } catch (e) {
                                console.log('OnAfterSSOLogin error', e);
                                this.authService.toggleSpinner();
                                throw e;
                            }
                        }
                    }).catch(reason => {
                        console.log('OnSSOLogin error', reason);
                        this.authService.toggleSpinner();
                    });

                    //this.authService.CheckVerificationEmail(this.newUser.email).then((verificationResult: string) => {
                    //    let dataVerificationEmail = { success: true, errorMessage: '', IsEmailVerified: false };
                    //    if (verificationResult && verificationResult.length) {
                    //        dataVerificationEmail = JSON.parse(verificationResult);
                    //        if (!dataVerificationEmail.IsEmailVerified) {
                    //            document.location.href = this.fullLiveUrl + 'verification-email';
                    //            this.authService.toggleSpinner();
                    //        }
                    //    }
                    //});
                }
                else {
                    console.log('GetToken error', "Incorrect email or password");
                    this.authService.toggleSpinner();
                    if (res.error_message === "error: your email not yet validated") {
                        this.isLicenseNotActivatedError = true;
                    }
                    else {
                        this.translate.get([this.incorrectEmailOrPassword]).subscribe((translations) => {
                            this.authService.AddErrorMessage(this.passwordInput, this.passwordWrongMsg, res.error_message && res.error_message === "error: username or password incorrect"
                                ? translations[this.incorrectEmailOrPassword]
                                : res.error_message);
                        });
                    }
                }
            });
        }
    }

    integrationSignUp(integrationCompany: IntegrationCompany): void {
        localStorage.setItem('packageTypeRegistration', 'foundation');
        this.redirectService.redirectToIntegrator(integrationCompany);
    }

    loadTranslations(): void {
        this.translate.get(['THE_EMAIL_ADDRESS_FIELD', 'NOT_A_VALID_EMAIL', 'THE_PASSWORD_FIELD_MUST']).subscribe(translations => {
                this.emailAddressRequired = translations['THE_EMAIL_ADDRESS_FIELD'];
                this.notValidEmail = translations['NOT_A_VALID_EMAIL'];
                this.passwordRequired = translations['THE_PASSWORD_FIELD_MUST'];
        });
    }
}